// components/DesktopAppMenu.tsx
import React, { useState } from "react";
import { 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  IconButton, 
  Tooltip 
} from "@mui/material";
import ComputerIcon from "@mui/icons-material/Computer";
import HearingIcon from "@mui/icons-material/Hearing";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { colors, components } from "../theme";

export type SystemType = 'hearing' | 'optics';

interface DesktopAppMenuProps {
  onSystemSelect: (system: SystemType) => void;
  disabled?: boolean;
}

export const DesktopAppMenu: React.FC<DesktopAppMenuProps> = ({
  onSystemSelect,
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSystemSelect = (system: SystemType) => {
    onSystemSelect(system);
    handleClose();
  };

  return (
    <>
      <Tooltip title="Open in desktop app">
        <IconButton 
          color="primary" 
          onClick={handleClick} 
          size="large"
          disabled={disabled}
        >
          <ComputerIcon
            sx={{
              fontSize: components.icon.large.width,
              color: colors.primary.main,
            }}
          />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuItem onClick={() => handleSystemSelect('hearing')}>
          <ListItemIcon>
            <HearingIcon fontSize="small" />
          </ListItemIcon>
          Open Hearing System
        </MenuItem>
        <MenuItem onClick={() => handleSystemSelect('optics')}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          Open Optics System
        </MenuItem>
      </Menu>
    </>
  );
};